import * as tslib_1 from "tslib";
import store from '../store/store';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { logUsage } from 'owa-analytics';
import { onListViewTypeOptionSaved } from 'owa-options-actions/lib/onListViewTypeOptionSaved';
var saveConversationsOptionStitchName = 'saveConversationsOptionStitchName';
var saveConversationsOption = action('saveConversationsOption')(function saveConversationsOption(newListViewType, conversationSortOrder, hideDeletedItems, userOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var serviceUpdates, sortOrderValue;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    serviceUpdates = [];
                    if (newListViewType !== null && newListViewType !== userOptions.GlobalListViewTypeReact) {
                        userOptions.GlobalListViewTypeReact = newListViewType;
                        onListViewTypeOptionSaved(newListViewType);
                        serviceUpdates.push({
                            propertyName: 'GlobalListViewTypeReact',
                            propertyType: 'Integer32',
                            propertyValue: "" + newListViewType,
                        });
                    }
                    if (conversationSortOrder) {
                        userOptions.ConversationSortOrderReact = conversationSortOrder;
                        sortOrderValue = void 0;
                        switch (userOptions.ConversationSortOrderReact) {
                            case 'Chronological':
                                sortOrderValue = 0x1;
                                break;
                            case 'Tree':
                                sortOrderValue = 0x2;
                                break;
                            case 'NewestOnTop':
                                sortOrderValue = 0x4;
                                break;
                            case 'NewestOnBottom':
                                sortOrderValue = 0x8;
                                break;
                            case 'ChronologicalNewestOnTop':
                                sortOrderValue = 0x5;
                                break;
                            case 'ChronologicalNewestOnBottom':
                                sortOrderValue = 0x9;
                                break;
                            case 'TreeNewestOnBottom':
                                sortOrderValue = 0xa;
                                break;
                        }
                        serviceUpdates.push({
                            propertyName: 'ConversationSortOrderReact',
                            propertyType: 'Integer32',
                            propertyValue: "" + sortOrderValue,
                        });
                    }
                    if (hideDeletedItems !== null) {
                        userOptions.HideDeletedItems = hideDeletedItems;
                        serviceUpdates.push({
                            propertyName: 'HideDeletedItems',
                            propertyType: 'Boolean',
                            propertyValue: "" + userOptions.HideDeletedItems,
                        });
                    }
                    // Raise stitch so that, if we're running in mail, the conversation cache will be cleaned
                    raiseAction(saveConversationsOptionStitchName)();
                    if (!serviceUpdates.length) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateUserConfiguration(serviceUpdates)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
});
export var saveConversationsOptionFull = select({
    userOptions: function () { return getUserConfiguration().UserOptions; },
    optionState: function () { return store; },
})(action('saveConversationsOptionFull')(function saveConversationsOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions, optionState = state.optionState;
                    return [4 /*yield*/, saveConversationsOption(optionState.globalListViewType, optionState.conversationSortOrder, optionState.hideDeletedItems, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingConversations';
export var saveConversationsOptionQuick = select({
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveConversationsOptionQuick')(function saveConversationsOptionQuick(isConversationViewEnabled, newSortOrder, state) {
    logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [newSortOrder]);
    saveConversationsOption(isConversationViewEnabled ? 0 /* Conversation */ : 1 /* Message */, newSortOrder, null, state.userOptions);
}));
//# sourceMappingURL=saveConversationsOption.js.map